import { Route } from "react-router-dom";

// Layout
import SuperAdminLayout from "../layouts/SuperAdminLayout";

// Pages
import SuperAdminAgentBuilder from "../pages/super-admin/SuperAdminAgentBuilder";
import SuperAdminApprovalRequest from "../pages/super-admin/SuperAdminApprovalRequest";
import SuperAdminDashboard from "../pages/super-admin/SuperAdminDashboard";
import SuperAdminInteriorLeads from "../pages/super-admin/SuperAdminInteriorLeads";
import SuperAdminOwner from "../pages/super-admin/SuperAdminOwner";
import SuperAdminProfileSubscription from "../pages/super-admin/SuperAdminProfileSubscription";
import SuperAdminPropertiesLeads from "../pages/super-admin/SuperAdminPropertiesLeads";

import NotFoundPage from "../pages/common/NotFoundPage";
import SuperAdminAdvertisements from "../pages/super-admin/SuperAdminAdvertisements";
import SuperAdminUpsertAdvertisements from "../pages/super-admin/SuperAdminUpsertAdvertisements";
import PropertyApprovalDetails from "../components/super-admin/approvals/PropertyApprovalDetails";

const SuperAdminRoutes = [
  <Route path="/super-admin" element={<SuperAdminLayout />}>
    {/* Dashboard */}
    <Route index element={<SuperAdminDashboard />} />

    <Route path="agents" element={<SuperAdminAgentBuilder />} />
    <Route path="owners" element={<SuperAdminOwner />} />

    {/* Leads Management */}
    <Route path="leads">
      <Route path="interior" element={<SuperAdminInteriorLeads />} />
      <Route path="properties" element={<SuperAdminPropertiesLeads />} />
    </Route>

    {/* Subscription / Profiles */}
    <Route
      path="profile-subscriptions"
      element={<SuperAdminProfileSubscription />}
    />

    <Route path="advertisements">
      <Route index element={<SuperAdminAdvertisements />} />
      <Route path="upsert" element={<SuperAdminUpsertAdvertisements />} />
    </Route>

    <Route path="approvals">
      <Route index element={<SuperAdminApprovalRequest />} />
      <Route path="details/:id" element={<PropertyApprovalDetails />} />
    </Route>

    {/* 404 */}
    <Route path="*" element={<NotFoundPage />} />
  </Route>,
];

export default SuperAdminRoutes;

// import { Route } from "react-router-dom";
// import MyProperties from "../pages/admin/MyProperties";
// import SuperAdminLayout from "../layouts/SuperAdminLayout";
// import SuperAdminDashboard from "../pages/super-admin/SuperAdminDashboard";
// import SuperAdminLeadResponse from "../pages/super-admin/SuperAdminLeadResponse";
// import SuperAdminPropertiesLeads from "../pages/super-admin/SuperAdminPropertiesLeads";
// import SuperAdminAgentBuilder from "../pages/super-admin/SuperAdminAgentBuilder";
// import SuperAdminOwner from "../pages/super-admin/SuperAdminOwner";
// import SuperAdminInteriorLeads from "../pages/super-admin/SuperAdminInteriorLeads";
// import SuperAdminApprovalRequest from "../pages/super-admin/SuperAdminApprovalRequest";
// import SuperAdminProfileSubscription from "../pages/super-admin/SuperAdminProfileSubscription";
// import NotFoundPage from "../pages/common/NotFoundPage";

// const SuperAdminRoutes = [
//   <Route path="/super-admin" element={<SuperAdminLayout />}>
//     <Route index element={<SuperAdminDashboard />} />
//     <Route path="leads" element={<SuperAdminLeadResponse />} />
//     <Route path="interior-leads" element={<SuperAdminInteriorLeads />} />
//     <Route path="agents-builder" element={<SuperAdminAgentBuilder />} />
//     <Route path="owners" element={<SuperAdminOwner />} />
//     <Route path="properties-leads" element={<SuperAdminPropertiesLeads />} />
//     <Route
//       path="profile-subscription"
//       element={<SuperAdminProfileSubscription />}
//     />
//     <Route path="approval-requests" element={<SuperAdminApprovalRequest />} />
//     <Route path="properties">
//       <Route index element={<MyProperties />} />
//     </Route>

//     {/* 404 catch-all */}
//     <Route path="*" element={<NotFoundPage />} />
//   </Route>,
// ];
// export default SuperAdminRoutes;
